import type { FlightResponse } from 'generatedTypes/flight/models';
import { calcDurationMinutes } from 'utils/dateTimeUtils/timeUtil';

const MINUTES_PER_HOUR = 60;

const formatDuration = (totalMinutes: number): string => {
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
    const minutes = Math.round(totalMinutes % MINUTES_PER_HOUR);

    if (hours === 0) {
        return `${minutes}m`;
    }

    return `${hours}h ${minutes}m`;
};

const getFlightGroupSummaryText = (flights: FlightResponse[]): string => {
    const flightCount = flights.length;
    const totalMinutes = flights.reduce(
        (total, flight) => total + calcDurationMinutes(flight.startTime, flight.endTime),
        0
    );
    const flightLabel = flightCount === 1 ? 'flight' : 'flights';

    return `${flightCount} ${flightLabel} \u00B7 ${formatDuration(totalMinutes)} total`;
};

export default getFlightGroupSummaryText;
